import { Directive, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getSystemLogPrivileges } from 'src/app/privileges/privileges.selector';
import { SystemLogsFilterOption } from './models/system-log-filter-option';
import { SystemLogPrivileges } from './models/system-log-privileges';
import { SystemLogRegisterOptions } from './models/system-log-register-options';
import { LogRegisterListItem } from './models/system-log-register-results.model';
import { logRegisterAdapterActions, logRegisterInitialFilter } from './state/system-log-register.actions';
import * as logRegisterReducer from './state/system-log-register.reducer';
@Directive()
export class LogRegister
   extends Register<LogRegisterListItem, SystemLogRegisterOptions, OrderingOption>
   implements OnInit
{
   columns: string[];

   filters: SystemLogsFilterOption[];

   entityName = 'Log';

   systemLogPrivileges$: Observable<SystemLogPrivileges>;

   isSystemUser$: Observable<boolean>;

   constructor(public store: Store) {
      super(store, logRegisterReducer.selectors, logRegisterAdapterActions);
      this.systemLogPrivileges$ = store.pipe(select(getSystemLogPrivileges));
   }

   ngOnInit() {
      this.store.dispatch(logRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }
}
